import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class EntityService {

  constructor(private http: HttpClient) { }

  /* request(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    data: Parámetros recibidos desde cada componente
    nameMethod: Método que se ejecutará en el controlador del api
  */
  request = (data: FormData, nameMethod: string): Observable<any> => this.http.post(environment.apiPath + "ApiEntity/" + nameMethod, data, HEADERS);

  // getEntityIndicators() llama la API de entidades para la información del home
  getEntityIndicators = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getAgreements() llama la API de entidades para la información de Convenios
  getAgreements = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getMobilized() llama la API de entidades para la información de Movilizado
  getMobilized = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getClaims() llama la API de entidades para la información de Reclamaciones
  getClaims = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

}
